const VFC_LOCATION_BOOKMARKS_KEY = 'VFC_LOCATION_BOOKMARKS_KEY';

export { VFC_LOCATION_BOOKMARKS_KEY };
